"use strict";
/**
 * @typedef {readonly [number,number]} Bounds
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.differentialEvolution = exports.sample = exports.ensureBounds = void 0;
/**
 * @param {number} val
 * @param {Bounds} bounds
 * @returns {number}
 */
function ensureBounds(val, bounds) {
    if (val < bounds[0]) {
        return bounds[0];
    }
    if (val > bounds[1]) {
        return bounds[1];
    }
    return val;
}
exports.ensureBounds = ensureBounds;
/**
 * @template T
 * @param {T[]} arr
 * @param {number} n
 * @returns {T[]}
 */
function sample(arr, n) {
    const result = [];
    const len = arr.length;
    const taken = Array(len).fill(false);
    if (n > len) {
        throw new RangeError('Sample larger than population');
    }
    while (result.length < n) {
        const randIdx = Math.floor(Math.random() * len);
        if (!taken[randIdx]) {
            taken[randIdx] = true;
            result.push(arr[randIdx]);
        }
    }
    return result;
}
exports.sample = sample;
/**
 * @template {readonly unknown[]} Args
 * @param {(vec: number, ...args: Args) => number} costFunc
 * @param {Bounds} bounds
 * @param {number} populationSize
 * @param {number} mutateRate
 * @param {number} recombinationRate
 * @param {number} maxIterations
 * @param {Args} args
 * @returns {number}
 */
function differentialEvolution(costFunc, bounds, populationSize = 15, mutateRate = 0.5, recombinationRate = 0.7, maxIterations = 250, ...args) {
    // Initialize a population
    const population = [];
    for (let i = 0; i < populationSize; i += 1) {
        const indv = Math.random() * (bounds[1] - bounds[0]) + bounds[0];
        population.push(indv);
    }
    let bestScore = Infinity;
    let bestSolution = Infinity;
    const genScores = [];
    for (let i = 0; i < maxIterations; i += 1) {
        for (let j = 0; j < populationSize; j += 1) {
            const candidates = [];
            for (let k = 0; k < populationSize; k += 1) {
                if (k !== j) {
                    candidates.push(k);
                }
            }
            const randomIndex = sample(candidates, 3);
            const x1 = population[randomIndex[0]];
            const x2 = population[randomIndex[1]];
            const x3 = population[randomIndex[2]];
            const xt = population[j];
            const xDiff = x2 - x3;
            const vDonor = x1 + mutateRate * xDiff;
            let vTrial;
            const crossover = Math.random();
            if (crossover <= recombinationRate) {
                vTrial = vDonor;
            }
            else {
                vTrial = xt;
            }
            vTrial = ensureBounds(vTrial, bounds);
            const scoreTrial = costFunc(vTrial, ...args);
            const scoreTarget = costFunc(xt, ...args);
            if (scoreTrial < scoreTarget) {
                population[j] = vTrial;
                genScores.push(scoreTrial);
            }
            else {
                genScores.push(scoreTarget);
            }
            if (scoreTrial < bestScore) {
                // console.log(`I have a new best score, ${scoreTrial} for ${vTrial}`);
                bestScore = scoreTrial;
                bestSolution = vTrial;
            }
        }
    }
    return bestSolution;
}
exports.differentialEvolution = differentialEvolution;
//# sourceMappingURL=differentialEvolution.js.map